/**
 * @generated SignedSource<<9858828dd3c92e2cd7b5ddb353e45c04>>
 * @relayHash cac609f1b5adb1f7064582d6b4625938
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5a13d887198ace35559a154088759b25831e249f357b45ff223bab473c6dcb26

import type { ConcreteRequest } from 'relay-runtime';
export type HelpCenterMediaConfigOperationType = "BANNER_UPLOAD" | "LOGO_UPLOAD" | "READ" | "%future added value";
export type HelpCenterNavigationBarBorderType = "ALL_BORDER" | "BOTTOM_BORDER" | "NO_BORDER" | "%future added value";
export type HelpCenterNavigationBarPositionType = "FIXED" | "FLOATING" | "%future added value";
export type HelpCenterType = "ADVANCED" | "BASIC" | "CUSTOMER_SERVICE" | "HELP_HUB" | "UNIFIED" | "%future added value";
export type hubQuery$variables = {
  cloudId: string;
  hubAri: string;
  operationType?: HelpCenterMediaConfigOperationType | null;
  pageAri: string;
};
export type hubQuery$data = {
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "HelpCenter";
      readonly helpCenterBranding: {
        readonly navigationBar: {
          readonly backgroundColor: string | null;
          readonly borderColor: string | null;
          readonly borderType: HelpCenterNavigationBarBorderType | null;
          readonly cornerRadius: number | null;
          readonly padding: boolean | null;
          readonly positionType: HelpCenterNavigationBarPositionType | null;
          readonly textColor: string | null;
        } | null;
      } | null;
      readonly name: {
        readonly default: string;
      } | null;
      readonly pages: ReadonlyArray<{
        readonly id: string;
        readonly name: {
          readonly default: string;
        } | null;
        readonly pageLayout: {
          readonly layoutAdf: {
            readonly content: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly content: string | null;
                } | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
      readonly type: HelpCenterType | null;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
    readonly pageMediaConfig: {
      readonly asapIssuer: string;
      readonly mediaCollectionName: string;
      readonly mediaToken: string;
      readonly mediaUrl: string;
    };
  } | null;
};
export type hubQuery = {
  response: hubQuery$data;
  variables: hubQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "operationType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageAri"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "ari",
    "variableName": "pageAri"
  },
  {
    "kind": "Variable",
    "name": "operationType",
    "variableName": "operationType"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "asapIssuer"
},
v7 = {
  "kind": "ScalarField",
  "name": "mediaCollectionName"
},
v8 = {
  "kind": "ScalarField",
  "name": "mediaToken"
},
v9 = {
  "kind": "ScalarField",
  "name": "mediaUrl"
},
v10 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "hubAri"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = [
  {
    "kind": "ScalarField",
    "name": "default"
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "concreteType": "HelpCenterName",
      "kind": "LinkedField",
      "name": "name",
      "plural": false,
      "selections": (v12/*: any*/)
    },
    {
      "concreteType": "HelpCenterBranding",
      "kind": "LinkedField",
      "name": "helpCenterBranding",
      "plural": false,
      "selections": [
        {
          "concreteType": "HelpCenterNavigationBar",
          "kind": "LinkedField",
          "name": "navigationBar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "backgroundColor"
            },
            {
              "kind": "ScalarField",
              "name": "borderColor"
            },
            {
              "kind": "ScalarField",
              "name": "borderType"
            },
            {
              "kind": "ScalarField",
              "name": "cornerRadius"
            },
            {
              "kind": "ScalarField",
              "name": "padding"
            },
            {
              "kind": "ScalarField",
              "name": "positionType"
            },
            {
              "kind": "ScalarField",
              "name": "textColor"
            }
          ]
        }
      ]
    },
    {
      "args": [
        {
          "fields": [
            {
              "items": [
                {
                  "kind": "Variable",
                  "name": "ids.0",
                  "variableName": "pageAri"
                }
              ],
              "kind": "ListValue",
              "name": "ids"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "HelpCenterPage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        (v13/*: any*/),
        {
          "concreteType": "HelpCenterPageName",
          "kind": "LinkedField",
          "name": "name",
          "plural": false,
          "selections": (v12/*: any*/)
        },
        {
          "concreteType": "HelpCenterPageLayout",
          "kind": "LinkedField",
          "name": "pageLayout",
          "plural": false,
          "selections": [
            {
              "concreteType": "HelpCenterLayoutAdf",
              "kind": "LinkedField",
              "name": "layoutAdf",
              "plural": false,
              "selections": [
                {
                  "concreteType": "HelpCenterLayoutAdfContentConnection",
                  "kind": "LinkedField",
                  "name": "content",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "HelpCenterLayoutAdfContentEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "HelpCenterLayoutAdfContent",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "content"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpCenter"
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "hubQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": "pageMediaConfig",
              "args": (v5/*: any*/),
              "concreteType": "HelpCenterMediaConfig",
              "kind": "LinkedField",
              "name": "hubMediaConfig",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v6/*: any*/),
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": (v7/*: any*/),
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": (v8/*: any*/),
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": (v9/*: any*/),
                  "action": "THROW"
                }
              ]
            },
            "action": "THROW"
          },
          {
            "args": (v10/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "hubQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "alias": "pageMediaConfig",
            "args": (v5/*: any*/),
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ]
          },
          {
            "args": (v10/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v13/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "5a13d887198ace35559a154088759b25831e249f357b45ff223bab473c6dcb26",
    "metadata": {},
    "name": "hubQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f2cb8e8955c5be850861a0d8de520f37";

export default node;
